import React from 'react';

const Error = () => {
	return <div>404 PAGE NOT FOUND</div>;
};

export default Error;
